export const MERGE_SYNC_STATUS: { [s in MergeSyncStatus]: MergeSyncStatus } = {
  DISABLED: 'DISABLED',
  DONE: 'DONE',
  FAILED: 'FAILED',
  // This pause is merge's pause
  PAUSED: 'PAUSED',
  SYNCING: 'SYNCING',
  // Statuses with the IMPORT prefix are set by us not merge
  IMPORT_FAILED: 'IMPORT_FAILED',
  // This is our pause to manually stop the import from TE
  IMPORT_PAUSED: 'IMPORT_PAUSED',
} as const;
